import { Button, Radio, Textarea } from "@mui/joy";
import { Backdrop, CircularProgress, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { DataGridPremium, GridFilterModel } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { Alert, Autocomplete, Avatar, Box, LinearProgress, Modal, Stack, TextField } from "@mui/material";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Send } from "@mui/icons-material";
import { set } from "lodash";

import Image from "@mui/icons-material/Image";
import totalLocationData from "../../../../data/locationdata";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    borderRadius: "24px",
    boxShadow: 24,
    p: 3,
    paddingLeft: 5,
    paddingRight: 5
};

const columns = [
    {
        field: "location", headerName: "지점", width: 100
    },
    {
        field: "seat", headerName: "좌석번호", width: 80
    },
    {
        field: "name", headerName: "이름", width: 180
    },
    {
        field: "selected", headerName: "선택", width: 80
    }
]

const TotalMessageSendModal: React.FC<any> = (props: any) => {

    const [loading2, setLoading2] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [data, setData] = useState<any>([]);

    const [whichType, setWhichType] = useState("text");

    const [imgLoading, setImgLoading] = useState(false);
    const [imgSrc, setImgSrc] = useState("");
    const [imgId, setImgId] = useState(0);

    const [fileName, setFileName] = useState<any>("");
    const [file, setFile] = useState<any>();

    const [isOver, setIsOver] = useState(false);


    const notify1 = () => toast.success("클립보드에 변수가 저장되었습니다. 원하는 곳에 붙여넣기 해주세요!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    const notify2 = () => toast.success("모든 메세지 전송이 완료되었습니다!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    const notify3 = () => toast.error("메세지 전송 중에 에러가 발생했습니다!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });


    // const handleClose = () => {
    //     setMessage("");
    //     setWhichType("text");
    //     setImgSrc("");
    //     setImgId(0);
    //     setIsOver(false);
    // }

    useEffect(() => {

        setMessage("");
        setWhichType("text");
        setImgSrc("");
        setImgId(0);
        setFileName("");
        setFile(undefined);
        setImgLoading(false);

    }, [props.open]);



    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                notify1();
            })
            .catch(err => {
                // 복사 실패 시 처리
                console.error('클립보드 복사에 실패했습니다.', err);
                alert('클립보드 복사에 실패했습니다.');
            });
    };

    const wait = async (ms: number) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(true);
            }, ms);
        })
    }

    const letsSendTotalMessages = async () => {

        try {

            if (!message && whichType === "text") {
                
                return;
            }

            if(!imgSrc && whichType === "img"){
                
                return;
            }

            if (props.selectedIds.length === 0) {
                
                return;
            }

            var targetMessage = "";

            switch (whichType) {
                case "text":
                    targetMessage = message;
                    break;
                case "img":
                    targetMessage = imgSrc;
                    break;
            }


            props.handleClose();
            setLoading2(true);

            const selectedIds = props.selectedIds;

            if(!selectedIds || selectedIds.length === 0){
                setLoading2(false);
                notify3();
                return;
            }


            const response = await fetch("https://peetsunbae.com/dashboard/envelope/sendMessageTotal", {
                method: "post",
                headers: {
                    "content-type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({
                    chatString: targetMessage, selectedIds, whichType
                })
            });

            const result = await response.json();

            setLoading2(false);

            props.handleClose();

            if(result.message === "success"){
                notify2();
            }else{
                notify3();
            }


        } catch (e) {
            
            setLoading2(false);
            notify3();
        }



    }



    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setWhichType(event.target.value);
    };

    const fileOnChange = (e: any) => {
        
        if (e.target && e.target.files.length > 0) {
            
            setFile(e.target.files[0]);
            setFileName(e.target.files[0].name);

            setImgLoading(true);

            var formData = new FormData();
            formData.append("chat_img", e.target.files[0]);

            fetch("https://peetsunbae.com/dashboard/envelope/img", {
                method: "post",
                credentials: "include",
                body: formData
            }).then((response: any) => {
                response.json()
                    .then((result: any) => {
                        
                        if (result.message === "success") {
                            setImgSrc(result.src);
                            setImgId(result.imgId);
                        }
                        setImgLoading(false);
                    })
            })

        }
    }

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
    }

    const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsOver(true);
        
    }

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsOver(false);
        
    }

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {

        e.preventDefault();
        
        

        if (e.dataTransfer.files.length === 0) {
            
            return;
        }

        if (e.dataTransfer.files.length !== 1) {
            alert("한 번에 한 장의 사진만 전송 가능합니다");
            return;
        }

        if (!e.dataTransfer.files[0].type.includes("image")) {
            alert("이미지 파일만 전송가능합니다");
            return;
        }

        const files = e.dataTransfer.files;

        setFile(files[0]);
        setFileName(files[0].name);

        setImgLoading(true);

        var formData = new FormData();
        formData.append("chat_img", files[0]);

        fetch("https://peetsunbae.com/dashboard/envelope/img", {
            method: "post",
            credentials: "include",
            body: formData
        }).then((response: any) => {
            response.json()
                .then((result: any) => {
                    
                    if (result.message === "success") {
                        setImgSrc(result.src);
                        setImgId(result.imgId);
                    }
                    setImgLoading(false);
                })
        })
    }



    return (
        <div>
            <Modal
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div style={{
                        fontFamily: "Apple_B",
                        fontSize: "20px",
                        marginBottom: "16px"
                    }}>
                        단체메세지 보내기
                    </div>
                    <div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            fontSize: "16px",
                            marginBottom: "6px"
                        }}>
                            보낼 대상
                        </div>
                        <div>
                            {
                                props.selectedLocations.map((eachLocation: any, index: number) => {
                                    if (eachLocation.names.length === 0) {
                                        return null;
                                    }

                                    var isNeedComma = true;

                                    if (index === props.selectedLocations.length - 1) {
                                        isNeedComma = false;
                                    } else if (props.selectedLocations[index + 1].names.length === 0) {
                                        isNeedComma = false;
                                    }

                                    return (
                                        <span key={index}>
                                            {eachLocation.location} {eachLocation.names.length}명
                                            {
                                                isNeedComma ? ", " : ""
                                            }
                                        </span>
                                    )
                                })
                            }
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            fontSize: "16px",
                            marginBottom: "8px",
                            marginTop: "16px"
                        }}>
                            보낼 메세지
                        </div>
                        <div style={{
                            marginTop: "12px",
                            marginBottom: "12px"
                        }}>
                            <Radio
                                checked={whichType === "text"}
                                onChange={handleChange}
                                value={"text"}
                                label="텍스트"
                                sx={{
                                    marginRight: "16px"
                                }}
                            />
                            <Radio
                                checked={whichType === "img"}
                                onChange={handleChange}
                                value={"img"}
                                label="이미지"
                            />
                        </div>
                        {
                            whichType === "text" &&
                            <div>
                                <Textarea minRows={6} maxRows={6}
                                    value={message}
                                    onChange={(e) => {
                                        setMessage(e.target.value);
                                    }}
                                />
                            </div>
                        }
                        {
                            (whichType === "img" && !imgLoading && !imgSrc) &&
                            <form encType="multipart/formdata">
                                <label htmlFor="file">
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "160px",
                                        border: "1px solid #e0e0e0",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        backgroundColor: isOver ? "#f0f0f0" : "#ffffff"
                                    }}
                                        onDrop={(e) => {
                                            handleDrop(e);
                                        }}
                                        onDragOver={(e) => { handleDragOver(e) }}
                                        onDragEnter={(e) => { handleDragEnter(e) }}
                                        onDragLeave={(e) => { handleDragLeave(e) }}
                                    >
                                        <Image
                                            fontSize="large"
                                            color="primary"
                                        />
                                        <input onChange={(e: any) => { fileOnChange(e) }} type="file" name="file" id="file" accept="image/*" hidden />
                                        <div style={{
                                            fontSize : "14px",
                                            marginTop : "8px"
                                        }}>
                                            클릭하거나 이미지를 드래그하여 업로드
                                        </div>
                                    </div>
                                </label>
                            </form>
                        }
                        {
                            (whichType === "img" && imgLoading) &&
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "160px",
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                cursor: "pointer"
                            }}>
                                <CircularProgress />
                            </div>
                        }
                        {
                            (whichType === "img" && !imgLoading && imgSrc) &&
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "160px",
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                cursor: "pointer"
                            }}>
                                <img 
                                    src={`https://peetsunbae.com/${imgSrc.split("/public/")[1]}`}
                                    alt="img" style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                }} />
                            </div>
                        }
                        {
                            whichType === "text" &&
                            <div style={{
                                marginTop: "8px"
                            }}>
                                <Button variant="soft" color="neutral"
                                    onClick={() => {
                                        copyToClipboard("#{이름+}");
                                    }}
                                >
                                    이름(성포함) 변수
                                </Button>
                                <Button variant="soft" color="neutral"
                                    onClick={() => {
                                        copyToClipboard("#{이름-}");
                                    }}
                                    style={{
                                        marginLeft: "8px"
                                    }}
                                >
                                    이름(성제외) 변수
                                </Button>
                                <Button variant="soft" color="neutral"
                                    onClick={() => {
                                        copyToClipboard("#{id}");
                                    }}
                                    style={{
                                        marginLeft: "8px"
                                    }}
                                >
                                    id 변수
                                </Button>
                            </div>

                        }

                        <div>
                            <Button variant="soft" color="primary"
                                style={{
                                    marginTop: "32px"
                                }}
                                size="lg"
                                fullWidth
                                startDecorator={
                                    <Send />
                                }
                                disabled={
                                    (whichType === "text" && !message) || (whichType === "img" && !imgSrc)
                                }
                                onClick={() => {
                                    letsSendTotalMessages();
                                }}
                            >
                                보내기
                            </Button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading2}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default TotalMessageSendModal;